import * as React from "react"
import LogoChatsbrook from "./logo-chatsbrook"
import InsuranceBanner from "../images/insurance.png"

const HomeBlocks = ({ className }) => {
  return (
    <section className={className}>
      <div className={"max-w-6xl mx-auto px-6 sm:px-4"}>
        <div className={"grid md:grid-cols-2 gap-6 md:gap-8"}>
          <a
            href={"https://www.chatsbrook.co.uk"}
            className={
              "w-full h-48 bg-grey-600 flex items-center justify-center transition duration-300 ease-in-out hover:bg-grey-700"
            }
            target={"_blank"}
            rel={"noreferrer"}
          >
            <LogoChatsbrook />
          </a>

          <a
            href={
              "https://www.insuranceprotector.co.uk/trailer-insurance-norfolk-referral/"
            }
            className={"relative h-48 w-full bg-[#00a9a0]"}
            target={"_blank"}
            rel={"noreferrer"}
          >
            <img
              src={InsuranceBanner}
              alt="Insurance Protector"
              className={"h-full object-contain"}
            />
          </a>
        </div>
      </div>
    </section>
  )
}

export default HomeBlocks
